module.exports = __webpack_public_path__ + "static/img/1-bg.f09ac4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/1-bg.png
// module id = 259r
// module chunks = 1